import { Tag } from "@sprout/tag.tsx";
import "@/stylesheets/applications/stages.scss";
import { Body } from "@sprout/typography.tsx";
import ArrowDownIcon from "@sprout/icons/arrow_down.tsx";
import ArrowUpIcon from "@sprout/icons/arrow_up.tsx";
import { IconButton } from "@sprout/icon_button.tsx";
import { useState } from "react";

interface Props {
  name: string;
  description?: string | null;
  isCurrentStage: boolean;
}

export const StageCard = ({ name, description, isCurrentStage }: Props) => {
  const [showDescription, setShowDescription] = useState(isCurrentStage);
  return (
    <>
      <div className="flex flex-col">
        <div className="flex">{isCurrentStage && <Tag label={"Current stage"}></Tag>}</div>
        <div className="flex justify-between">
          <Body>{name}</Body>
          {!!description &&
            (showDescription ? (
              <IconButton
                label={"collapse"}
                size="sm"
                icon={ArrowUpIcon}
                onClick={() => setShowDescription(false)}
              />
            ) : (
              <IconButton
                label={"expand"}
                size="sm"
                icon={ArrowDownIcon}
                onClick={() => setShowDescription(true)}
              />
            ))}
        </div>
      </div>
      {!!description && showDescription && (
        <div className="stage-description" dangerouslySetInnerHTML={{ __html: description }}></div>
      )}
    </>
  );
};
